<div class="flex h-full w-full flex-row items-center">
  <div class="truncate">{{ params.value }}</div>
</div>

<div *ngIf="uiQuery$ | async"></div>
<div *ngIf="report$ | async"></div>
